import React from "react";
import "./search-input.css";

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Extra class hook for width/layout overrides in a specific context. */
  className?: string;
  "aria-label"?: string;
}

/**
 * Shared search field: a styled `type="search"` input driven entirely by its
 * parent. Pairs with {@link useSearch}, which owns the query state and the
 * filtering, keeping this component purely presentational.
 */
function SearchInput({
  value,
  onChange,
  placeholder = "Search…",
  className,
  "aria-label": ariaLabel,
}: Props) {
  return (
    <input
      className={`search-input${className ? ` ${className}` : ""}`}
      type="search"
      placeholder={placeholder}
      value={value}
      aria-label={ariaLabel ?? placeholder}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export default SearchInput;
